import { uuid as vueUuid } from "vue-uuid";
import moment from "moment";

/**
 * Creates a v4 UUID.
 * @returns {Promise<string>}
 */
export async function uuid() {
  return await vueUuid.v4();
}

/**
 * Creates a v4 UUID (in sync way)
 * @return {string}
 */
export function syncUUID() {
  return vueUuid.v4();
}

/**
 * Reads the file input object specified and returns the contents as a data url
 * @returns {Promise<unknown>}
 */
export async function readFileAsDataURL(file: any) {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });
}

/**
 * Get image dimensions from file
 * @param fileDataUrl
 */
export async function getImageDimensions(fileDataUrl: any) {
  return new Promise(function(resolved, rejected) {
    const i = new Image();
    i.onload = function() {
      resolved({ width: i.width, height: i.height });
    };
    i.src = fileDataUrl;
  });
}

/**
 *
 * @param millis
 * @param tz
 * @returns {Promise<void>}
 */
export async function minutesUntilEventStartTime(millis: number, tz: any) {
  const now = moment();
  const then = moment(millis);
  return then.diff(now, "minutes");
}

/**
 *
 */
export function formatEventStartTime(millis: number, tz: any) {
  const then = moment(millis);
  return then.calendar({
    sameDay: "h:mm[<small>]a[</small>]",
    nextDay: "[Tomorrow at] h:mm[<small>]a[</small>]",
    nextWeek: "ddd [at] h:mm[<small>]a[</small>]",
    sameElse: "MMM D, h:mm[<small>]a[</small>]"
  });
}

export function formatEventEndTime(millis: number) {
  const then = moment(millis);

  return then.calendar({
    sameDay: "h:mm[<small>]a[</small>]",
    nextDay: "h:mm[<small>]a[</small>]",
    nextWeek: "h:mm[<small>]a[</small>]",
    sameElse: "h:mm[<small>]a[</small>]"
  });
}

export function formatDate(date: Date) {
  const m = moment(date);
  return m.format("MMM Do");
}

export function formatPhoneNumber(phone: string) {
  const cleaned = ("" + phone).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return "";
}
